import posthog from 'posthog-js'
import { ICurrentUser } from '@query'
import { getUserDisplayName } from './helpers'
import { omitEmptyValues } from './omitEmptyValues'

export const identifyPostHogUser = (user: ICurrentUser): void => {
  if (!user?.id) return

  const name = getUserDisplayName(user, { fallbackToEmail: true })
  const properties = omitEmptyValues({
    email: user.email,
    name,
    first_name: user.first_name,
    last_name: user.last_name,
    language: user.language,
    subscription_tier: user.subscription_tier
  })
  posthog.identify(String(user.id), properties)
}

export const getPostHogConfig = () => {
  const analyticsEnv = import.meta.env.VITE_ANALYTICS_ENVIRONMENT ?? 'lcl'
  const isAnalyticsProd = analyticsEnv === 'prd'

  const postHogKey =
    analyticsEnv === 'prd'
      ? import.meta.env.VITE_PUBLIC_POSTHOG_KEY_PRD
      : analyticsEnv === 'tst'
      ? import.meta.env.VITE_PUBLIC_POSTHOG_KEY_TST
      : import.meta.env.VITE_PUBLIC_POSTHOG_KEY_LCL

  const postHogHost =
    analyticsEnv === 'prd'
      ? import.meta.env.VITE_PUBLIC_POSTHOG_HOST_PRD
      : analyticsEnv === 'tst'
      ? import.meta.env.VITE_PUBLIC_POSTHOG_HOST_TST
      : import.meta.env.VITE_PUBLIC_POSTHOG_HOST_LCL

  const postHogOptions = {
    api_host: postHogHost,
    defaults: '2025-11-30', // Date selects the default config from PostHog
    // Avoid cookies until consent is granted.
    cookieless_mode: 'on_reject',
    // Start recording only after Cookiebot statistics consent (see usePostHogCookiebotConsent).
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true
    }
  } as const

  return { postHogKey, postHogHost, postHogOptions, isAnalyticsProd }
}

export const getPostHogClient = () => {
  const analyticsEnv = import.meta.env.VITE_ANALYTICS_ENVIRONMENT ?? 'lcl'
  if (analyticsEnv === 'lcl') return posthog

  const { postHogKey, postHogOptions } = getPostHogConfig()

  posthog.init(postHogKey, postHogOptions)

  return posthog
}
